import React, { Dispatch, SetStateAction } from 'react';

import {
  keepPreviousData,
  useQuery,
  UseQueryResult,
} from '@tanstack/react-query';

import {
  GetValidJuridictionByLibelleOrNumeroUsingGETQueryParams,
  JuridictionResponseDto,
} from 'lib_api/lib/api/gen';

import { useApi } from '../ApiStoreContext';
import { backAlertMessage } from '../utils/backAlertMessage';

export const useGetJuridictionQuery = (): {
  query: UseQueryResult<JuridictionResponseDto[], Error>;
  setSearched: Dispatch<SetStateAction<string>>;
} => {
  const [searched, setSearched] = React.useState<string>('');

  const { ReferentielControllerApi: controller } = useApi();

  const fetchData = async () => {
    const queryParams: GetValidJuridictionByLibelleOrNumeroUsingGETQueryParams =
      { field: 'LIBELLE', searched };
    const result = await controller
      .getValidJuridictionByLibelleOrNumeroUsingGET(queryParams)
      .catch((e: Response) => {
        void backAlertMessage(e);
        throw e;
      });
    return result.reference.referenceDtoList;
  };

  return {
    query: useQuery({
      queryKey: ['searchJuridictionByLibelle', searched],
      queryFn: fetchData,
      retry: false,
      placeholderData: keepPreviousData,
    }),
    setSearched,
  };
};
